import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, Snowflake } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      // withCredentials lets the httpOnly cookie set by the backend be stored & sent on future calls.
      await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Contraseña incorrecta");
      setLoading(false);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center justify-center px-5 py-16">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border-[3px] border-[#0C0A09] shadow-[8px_8px_0_0_#0C0A09] p-8 md:p-10"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full bg-[#FF3D7F] border-[3px] border-[#0C0A09] flex items-center justify-center">
            <Snowflake size={20} strokeWidth={3} />
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] opacity-70">Velora</div>
            <h1 className="font-display text-3xl leading-none">Admin</h1>
          </div>
        </div>

        <label className="text-[10px] font-bold uppercase tracking-[0.2em] block mb-2">Contraseña</label>
        <div className="relative">
          <Lock size={18} strokeWidth={2.5} className="absolute left-3 top-1/2 -translate-y-1/2 opacity-60" />
          <input
            data-testid="admin-password-input"
            type="password"
            autoFocus
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#FAF9F6] border-[3px] border-[#0C0A09] pl-10 pr-3 py-3 font-bold focus:outline-none focus:shadow-[3px_3px_0_0_#0C0A09]"
            placeholder="••••••••"
          />
        </div>
        {error && (
          <div data-testid="admin-login-error" className="mt-3 text-sm font-bold text-[#FF3D7F]">
            {error}
          </div>
        )}
        <button
          data-testid="admin-login-submit"
          disabled={loading}
          className="nb-btn w-full justify-center mt-6 disabled:opacity-60"
        >
          {loading ? "..." : "Entrar →"}
        </button>
        <p className="mt-6 text-[10px] text-center uppercase tracking-[0.2em] opacity-60">Acceso solo para administradores</p>
      </form>
    </section>
  );
}
